import { api } from '@/shared/api/http'
import type { ThemePreference } from './types'

/**
 * 테마를 고른 것을 계정에 남긴다.
 *
 * 읽는 자리를 따로 두지 않는다. 계정에 남은 값은 Session 확인 응답이 함께 나르므로 앱을 여는
 * 왕복 하나로 끝난다.
 */
export function updateThemePreference(preference: ThemePreference): Promise<ThemePreference> {
  return api.put<ThemePreference>('/me/theme-pref', preference)
}
